<template>
  <div class="system-health-container">
    <div class="status-card">
      <div class="card-header">
        <div class="header-left">
          <span class="title-text">系統健康統計表</span>
        </div>
      </div>

      <el-table
        :data="healthStatisticsData"
        border
        stripe
        style="width: 100%"
        :header-cell-style="headerStyle"
        class="custom-table"
      >
        <el-table-column prop="deviceType" label="類別" align="center" min-width="150"></el-table-column>
        
        <el-table-column prop="total" label="總數" align="center" width="120">
          <template slot-scope="scope">
            <span class="total-count">{{ scope.row.total }}</span>
          </template>
        </el-table-column>

        <el-table-column label="正常" align="center" min-width="120">
          <template slot-scope="scope">
            <span class="green-text">{{ scope.row.greenCount }}</span>
          </template>
        </el-table-column>

        <el-table-column label="未更新" align="center" min-width="150">
          <template slot-scope="scope">
            <el-tooltip v-if="scope.row.downList.length > 0" placement="top" effect="dark">
              <div slot="content" class="tooltip-content">
                <div v-for="name in scope.row.downList" :key="name" class="name-item">{{ name }}</div>
              </div>
              <div class="status-badge down-badge">{{ scope.row.downCount }}</div>
            </el-tooltip>
            <span v-else class="zero-text">0</span>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SystemHealth',
  props: {
    battList: {
      type: Array,
      default: () => [],
    },
    loggerList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      headerStyle: {
        backgroundColor: '#ecf5ff',
        color: '#409eff',
        fontWeight: 'bold',
        fontSize: '14px',
      },
      typeNameMap: {
        'Gateway': 'IoT Gateway 設備狀態',
        'NODE': 'IoT Node 電力狀態',
        'Logger': 'CR1000X 設備狀態',
        'CR1000': 'CR1000X 電力狀態',
        'CCTV': 'CCTV 設備狀態',
        'UPS': 'UPS 電力狀態',
      },
    };
  },
  computed: {
    healthStatisticsData() {
      const typeMap = {};

      this.battList.forEach(item => {
        const name = item.latestVersion?.name || '未知設備';
        const status = item.status || 'GREEN';

        let deviceCode = 'OTHER';
        if (name.includes('UPS')) {
          deviceCode = 'UPS';
        } else if (name.includes('(Batt)')) {
          deviceCode = 'NODE';
        } else if (name.includes('-Batt')) {
          deviceCode = 'CR1000';
        } else if (name.includes('-CCTV')) {
          deviceCode = 'CCTV';
        } else {
          return;
        }
        

        if (!typeMap[deviceCode]) {
          typeMap[deviceCode] = {
            total: 0,
            greenCount: 0,
            downCount: 0,
            downList: [],
          };
        }

        const data = typeMap[deviceCode];
        data.total += 1;

        if (status === 'down') {
          data.downCount += 1;
          data.downList.push(name);
        } else {
          data.greenCount += 1;
        }
      });

      // 需要分類 name，包含 _Data.dat 的歸類為 logger，剩下的歸類在 Gateway
      this.loggerList.forEach(doc => {
        const name = doc.name || '未知 Logger';
        const status = doc.status || 'activate';
        // 都不是就 return 掉不處理，因為只關心 Logger 與 Gateway 兩種設備
        const deviceCode = doc.name && doc.name.includes('_Data.dat') ? 'Logger' : 'Gateway';

        if (!deviceCode) {
          return;
        }

        if (!typeMap[deviceCode]) {
          typeMap[deviceCode] = {
            total: 0,
            greenCount: 0,
            downCount: 0,
            downList: [],
          };
        }

        const data = typeMap[deviceCode];
        data.total += 1;

        if (status === 'down') {
          data.downCount += 1;
          data.downList.push(name);
        } else {
          data.greenCount += 1;
        }
      });

      const order = Object.keys(this.typeNameMap);

      return Object.keys(typeMap)
        .sort((a, b) => {
          const indexA = order.indexOf(a);
          const indexB = order.indexOf(b);
          return (indexA === -1 ? 999 : indexA) - (indexB === -1 ? 999 : indexB);
        })
        .map(code => {
          return {
            deviceType: this.typeNameMap[code] || `${code} 設備`,
            total: typeMap[code].total,
            greenCount: typeMap[code].greenCount,
            downCount: typeMap[code].downCount,
            downList: typeMap[code].downList.sort(),
          };
        });
    },
  },
};
</script>

<style scoped>
.system-health-container {
  height: 100%;
  display: flex;
  flex-direction: column;
}

.status-card {
  flex: 1;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 12px 0 rgba(0,0,0,0.1);
  padding: 20px;
}
.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  padding-bottom: 10px;
  border-bottom: 2px solid #ebeef5;
}

.header-left {
  display: flex;
  align-items: center;
}

.title-text {
  margin-top: 10px;
  margin-left: 10px;
  font-size: 16px;
  font-weight: bold;
  color: #303133;
}

.status-badge { display: inline-block; padding: 2px 10px; border-radius: 12px; font-weight: bold; font-size: 13px; cursor: pointer; }
.al-badge { background-color: #fdf6ec; color: #e6a23c; border: 1px solid #faecd8; }
.wsl-badge { background-color: #fef0f0; color: #f56c6c; border: 1px solid #fde2e2; }
.down-badge { background-color: #f4f4f5; color: #909399; border: 1px solid #e9e9eb; }
.total-count { color: #409eff; font-weight: bold; }
.green-text { color: #67c23a; font-weight: bold; }
.zero-text { color: #c0c4cc; }
.tooltip-content { max-height: 200px; overflow-y: auto; }
.name-item { padding: 2px 0; border-bottom: 1px solid #505050; }
</style>